import { Option, Select } from 'app/components/fields/Select';
import type { Experience } from 'app/typings/experiences';
import type { Space } from 'app/typings/hotels/Space/Space';
import type { SpaceType } from 'app/typings/hotels/SpaceType/SpaceType';

export const NOT_APPLICABLE_SPACE_ID = -1;

export const SpacesSelect = ({
  value = [],
  onChange,
  hotelSpaces,
  spaceTypes,
  mode,
  notApplicableOption = false,
  setFieldsValue,
  id,
}: Props) => {
  const safeValue = value ?? [];

  const displayNotApplicableOption =
    notApplicableOption &&
    (safeValue.length === 0 || safeValue.includes(NOT_APPLICABLE_SPACE_ID));

  return (
    <Select
      id={id}
      value={safeValue}
      onSelect={(selected) => {
        if (
          selected !== NOT_APPLICABLE_SPACE_ID &&
          safeValue.includes(NOT_APPLICABLE_SPACE_ID)
        ) {
          setFieldsValue({
            spaceIds: [
              ...safeValue.filter((v) => v !== NOT_APPLICABLE_SPACE_ID),
              selected,
            ],
          });
        }
      }}
      onChange={(newValue) => {
        if (onChange) {
          onChange(newValue);
        }
      }}
      mode="multiple"
      allowClear
      showSearch
      showArrow
      disabled={mode === 'view'}
    >
      {hotelSpaces &&
        hotelSpaces.map((space) => {
          const spaceTypeName =
            spaceTypes.find((spaceType) => spaceType.id === space.spaceTypeId)
              ?.name || '';
          const spaceName = space.name ? `(${space.name})` : '';

          return (
            <Option key={space.id} value={space.id}>
              {`${spaceTypeName} ${spaceName}`}
            </Option>
          );
        })}
      {displayNotApplicableOption && <Option value={-1}>Not applicable</Option>}
    </Select>
  );
};

type Props = {
  value?: number[];
  onChange?: (newValue: number[]) => void;
  hotelSpaces: Space[];
  spaceTypes: SpaceType[];
  mode?: string;
  notApplicableOption?: boolean;
  setFieldsValue: (values: Partial<Experience>) => void;
  id?: string;
};
